import { ReactElement, useState } from 'react'
import { Tooltip as MuiTooltip, Box, IconButton } from '@mui/material'
import { Button, Checkbox } from 'src/ui-components'
import CloseIcon from '@mui/icons-material/Close'
import { StoreInstances } from 'src/store/StoreInstancesContainer'
import { I18n, Translate2 } from 'common'

interface TooltipProps {
  children: ReactElement
  show: boolean
  placement?: 'bottom' | 'top' | 'left' | 'right'
}

export const MultiSellerInterchangeTooltip = (
  props: TooltipProps
): ReactElement => {
  const { children, placement = 'bottom', show = true } = props
  const [open, setOpen] = useState(false)
  const [showModel, setShowModel] = useState(false)
  const { userId } = StoreInstances.userStore.preferences
  const handleTooltipOpen = () => {
    setOpen(show)
  }

  const handleTooltipClose = () => {
    setOpen(show)
  }
  const handleTooltipCloseBtn = () => {
    setOpen(false)
  }
  const dismissHandler = () => {
    if (!showModel) {
      handleTooltipCloseBtn()
    }
    if (showModel) {
      const storageKey = `${userId}_multiseller_tooltip_display`
      localStorage.setItem(storageKey, 'false')
      handleTooltipCloseBtn()
    }
  }

  return (
    <MuiTooltip
      PopperProps={{
        sx: {
          '.MuiTooltip-tooltip': {
            bgcolor: 'white',
            color: 'black',
            border: '1px solid black',
            maxWidth: '534px',
            padding: '16px',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          },
        },
      }}
      title={
        <Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={1}
          >
            <p
              style={{
                fontSize: '14px',
                fontFamily: 'Oswald',
                fontWeight: '700',
                lineHeight: '21px',
                margin: 0,
              }}
            >
              <I18n name="interchangeTooltipHeading" />
            </p>
            <IconButton
              size="small"
              onClick={handleTooltipCloseBtn}
              aria-label={Translate2('close')}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          <p
            style={{
              fontSize: '14px',
              fontFamily: 'Roboto',
              fontWeight: '400',
              lineHeight: '24px',
              margin: 0,
            }}
          >
            <I18n name="interchangeResultsAreAvailableText" />
          </p>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <label>
              <Checkbox
                onClick={() => {
                  setShowModel(!showModel)
                }}
                value="checkbox"
                label={Translate2('dontShowThisAgain')}
                active={showModel}
              />
            </label>
            <Button text="dismiss" onClick={dismissHandler} />
          </Box>
        </Box>
      }
      placement={placement}
      arrow
      open={open}
      onClose={handleTooltipClose}
      onOpen={handleTooltipOpen}
    >
      <span>{children}</span>
    </MuiTooltip>
  )
}
